import { render, staticRenderFns } from "./photo_clock_time.vue?vue&type=template&id=ae87633a"
import script from "./photo_clock_time.vue?vue&type=script&lang=js"
export * from "./photo_clock_time.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae87633a')) {
      api.createRecord('ae87633a', component.options)
    } else {
      api.reload('ae87633a', component.options)
    }
    module.hot.accept("./photo_clock_time.vue?vue&type=template&id=ae87633a", function () {
      api.rerender('ae87633a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/attendance_manage/rule/components/photo_clock_time.vue"
export default component.exports